// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"ab4dd3f5","977":"3b715f17"}[chunkId] + ".chunk.js";
};